/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const FindFormContainer = styled.div`
  width: 480px;
  display: flex;
  flex-direction: column;
  padding: 40px 40px 80px 40px;
  margin: 0 auto;
  align-items: center;
  box-sizing: border-box;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  margin-bottom: 40px;
  width: 100%;
  gap: 4px;
`;

export const LoginBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
